const log = {
    invalid_type: 'Der Log Typ ist ungültig.',
};
export default Object.freeze(log);
